const visitorManagementEn = {
    inOut: require('lang/en/visitorManagement/InOut').default,
    preApprovedVisitor: require('lang/en/visitorManagement/PreApprovedVisitor').default,
    visitorApprovalRequest: require('lang/en/visitorManagement/VisitorApprovalRequest').default,
    myVisitor: require('lang/en/visitorManagement/MyVisitor').default,
    overStay: require('lang/en/visitorManagement/OverStay').default,
};

export default visitorManagementEn;